module.exports = __webpack_public_path__ + "img/ic_logo_walker@2x.b2867064.png";